import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../config.json';
import NavMenu from './NavMenu';

const apiUrl = config.apiUrl;
const Home = () => {
  const [loading, setLoading] = useState(true);
  const [overtimeCount, setOvertimeCount] = useState(0);
  const [leaveCount, setLeaveCount] = useState(0);
  const [undertimeCount, setUndertimeCount] = useState(0);
  const [timeEntryCount, setTimeEntryCount] = useState(0);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();

  const roles = JSON.parse(localStorage.getItem('Roles'));

  const userAccess = {
    hasView: roles?.includes('View') || false,
    hasAdmin: roles?.includes('Admin') || false,
    hasApprover: roles?.includes('Approver') || false,
    hasStandard: roles?.includes('Standard') || false,
    hasReviewer: roles?.includes('Reviewer') || false,
    };

  const { hasView, hasAdmin, hasStandard, hasApprover, hasReviewer } = userAccess;

  useEffect(() => {
    redirectToPath();
  }, []);

  const redirectToPath = () => {
    // Navigate to the report view path if the user is an admin
    if (hasAdmin) {
      navigate('/reportviews');
    }
    else if(hasStandard) {
      navigate('/employee-list');
    }
    else if (hasReviewer) {
      navigate('/reportviews');
    }
  };

  useEffect(() => {
    fetchApprovalCounts();
  }, []);
  const fetchApprovalCounts = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(`${apiUrl}/ReportView/ForApprovalCounts`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setOvertimeCount(data.OvertimeCount || 0);
        setLeaveCount(data.LeaveCount || 0);
        setUndertimeCount(data.UndertimeCount || 0);
        setTimeEntryCount(data.TimeEntryCount || 0);
      }
    } catch (error) {
      setErrorMessage('Error fetching data');
      setSuccessMessage('');
    }
  };

  return (
    <div>
      {hasApprover ? (
        <>
          <h3>For Approval</h3>
          {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
          {successMessage && <div className="alert alert-success">{successMessage}</div>}
          <p>Overtime: {overtimeCount}</p>
          <p>Leave: {leaveCount}</p>
          <p>Undertime: {undertimeCount}</p>
          <p>Time Entries: {timeEntryCount}</p>
        </>
      ) : (
        <div>
          <h3>No access!</h3>
          <button className="btn btn-primary" onClick={() => navigate(-1)}>
            Go Back
          </button>
        </div>
      )}
    </div>
  )
};

export default Home;
